export const customStyles = {
  control: (styles) => ({
    ...styles,
    width: "12rem",
    borderRadius: "36px",
    color: "#000",
    fontSize: "0.8rem",
    lineHeight: "1.75rem",
    backgroundColor: "#2C2C2C",
    cursor: "pointer",
    border: "2px solid #000000",
    ":hover": {
      border: "2px solid #000000",
      boxShadow: "none",
    },
  }),
  option: (styles) => {
    return {
      ...styles,
      color: "#fff",
      fontSize: "0.8rem",
      lineHeight: "1.75rem",
      width: "100%",
      background: "#2C2C2C",
      ":hover": {
        backgroundColor: "#4F4F4F",
        color: "#fff",
        cursor: "pointer",
      },
    };
  },
  menu: (styles) => {
    return {
      ...styles,
      backgroundColor: "#2C2C2C",
      maxWidth: "14rem",
      border: "2px solid #000000",
      borderRadius: "5px",
      boxShadow: "5px 5px 0px 0px rgba(0,0,0);",
    };
  },
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#fff",
      fontSize: "0.8rem",
      lineHeight: "1.75rem",
    };
  },
  indicatorSeparator: (styles) => {
    return {
      ...styles,
      display: "none"
    }
  },
  valueContainer : (styles) => {
    return {
      ...styles,
      color: "#fff"
    }
  },
  singleValue : (styles) => {
    return {
      ...styles,
      color: "#fff"
    }
  }
};
